import React from "react";
import dynamic from "next/dynamic";
import { GamesCardListSkeleton } from "@/components/webview/games/core/GamesCardListSkeleton";
import { GamesButtonWebView } from "@/components/webview/games/shared/GamesButtonWebView";
import { useTrans } from "@/utils/useTrans";
import { LayoutGamesWebView } from "@/components/webview/games/layout/LayoutGamesWebView";
import { WEBVIEW_ROUTES } from "@/components/webview/route";
import Link from "next/link";
import { Button1 } from "@/components/webview/games/typograpy/typograpy-webview";

//TODO intersection observer 감지시 순차적으로 렌더하도록
export const LazyGamesCompatibleGamesWebView = dynamic(
  () => import("./GamesCompatibleGamesWebView"),
  {
    ssr: false,
    loading: () => <div className="min-h-[446px]" />,
  },
);

export const LazyGamesNewGamesWebView = dynamic<{ className?: string }>(
  () => import("./GamesNewGamesWebView"),
  {
    ssr: false,
    loading: () => (
      <LayoutGamesWebView
        className={"min-h-[310px] bg-[#1C1C1C] py-4"}
        header={<p className="px-4">{"New Games"}</p>}
        contents={
          <GamesCardListSkeleton
            cardCount={3}
            className={"flex bg-[#1C1C1C]"}
            cardWidth={"w-[100px]"}
          />
        }
      />
    ),
  },
);

export const LazyGamesUpcomingGamesWebView = dynamic<{ className?: string }>(
  () => import("./GamesUpcomingGamesWebView"),
  {
    ssr: false,
    loading: () => (
      <LayoutGamesWebView
        className="min-h-[310px] bg-black py-4"
        header={<p className="px-4">{"Upcoming Games"}</p>}
        contents={
          <GamesCardListSkeleton
            cardCount={3}
            className="flex bg-black"
            cardWidth={"w-[100px]"}
          />
        }
      />
    ),
  },
);

export const LazyGamesWeeklyTrendingWebView = dynamic(
  () => import("./GamesWeeklyTrendingWebView"),
  {
    ssr: false,
    loading: () => (
      <LayoutGamesWebView
        className="min-h-[720px] bg-black py-4"
        header={<p className="px-4">{"Weekly Trending Games"}</p>}
        contents={<GamesCardListSkeleton />}
      />
    ),
  },
);

const GamesLazySectionsWebView = () => {
  const { t } = useTrans(["games"]);
  return (
    <div className="flex flex-col gap-[38px] bg-black">
      <LazyGamesCompatibleGamesWebView />
      <LazyGamesUpcomingGamesWebView className={"py-5"} />
      <LazyGamesNewGamesWebView className={"bg-[#1C1C1C] py-5"} />
      <LazyGamesWeeklyTrendingWebView />

      <LayoutGamesWebView
        className="px-4 pb-10 pt-6"
        contents={
          <Link href={WEBVIEW_ROUTES.webviewSearch}>
            <GamesButtonWebView className="h-[50px]">
              <Button1 className="font-500">{t("See All Games")}</Button1>
            </GamesButtonWebView>
          </Link>
        }
      />
    </div>
  );
};

export default GamesLazySectionsWebView;
